import { Service } from '@repo/core'
import { ExternalToolLinkParams, ExternalToolLinkResponse } from '@repo/shared-types'

export const loadExternalToolLink: Service<
  ExternalToolLinkParams,
  ExternalToolLinkResponse
> = async ({ api, params }) => {
  const { action, ...queryParams } = params
  return api.get<ExternalToolLinkResponse>(`/tools/external/${params.action}/link`, {
    params: queryParams,
  })
}
